<section #sidebar class="sidebar-wrapper">
    <aside class="sidebar shadow">
      <div class="content">
        <a routerLink="/cadastro/vistoria" class="logo" tooltip="Listagem de Vistoria" placement="left">
          <img src="./assets/images/logobranco.png" alt="Planetun" />
        </a>
      </div>
    </aside>
    